import { render, staticRenderFns } from "./ExameFisico.vue?vue&type=template&id=e77e4f14"
import script from "./ExameFisico.vue?vue&type=script&lang=js"
export * from "./ExameFisico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports